<template>

    <m-edit1/>

    <m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard903s","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","showCategoriesSlider":false,"offerType":"number","offerStatus":true,"productBrandProp":true,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":false,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":true,"productStoresProp":false,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":false,"showKeywords":false,"smCardName":"mProductCard903s","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":true,"infinityLoading":true,"chooseCategoriesFromTop":false,"cardLinkTarget":"_blank","productStoresDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"archiveFilterProp":false},...{}}' :style='""' class="my-4 product-archive-3" ></m-products-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
